import { CardMedia } from '@mui/material';
import React from 'react';

function VideoItem({ video }) {
  return (
    <CardMedia
      src={`${video}?enablejsapi=1&rel=0`}
      image={`${video}?enablejsapi=1&rel=0`}
      component="iframe"
      allowFullScreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      frameBorder="0"
      title="Embedded youtube"
      sx={{
        height: '100%',
        width: '100%',
      }}
    />
  );
}

export default VideoItem;
